export default {
  forward: 'Forward',
  reply: 'Reply',
  ignore: 'Ignore',
  toVoicemail: 'To Voicemail',
  answer: 'Answer',
  answerAndEnd: 'Answer & End',
  answerAndHold: 'Answer & Hold',
} as const;
